<template>
  <div class="cart-container">
    <div style="padding: 1.5rem">
      <div class="cart-header">
        <p class="cart-title">Košaricaaa</p>
        <main-button
          v-if="showEdit"
          outline
          class="edit-button"
          color="black"
          @click="$emit('edit')"
        >
          Uredi
          <v-icon style="margin-left: 8px">edit </v-icon>
        </main-button>
      </div>
      <table class="wp-table">
        <tr>
          <th>{{ $t('ticketType') }}</th>
          <th>{{ $t('ticketQuantity') }}</th>
          <th style="text-align: right">{{ $t('price') }}</th>
        </tr>
        <tr v-for="data in modifyOrderData()" :key="data.id">
          <td>{{ data.name }}</td>
          <td>{{ data.count }}</td>
          <td style="text-align: right">
            <span> {{ data.price }} {{ data.currency }} </span>
          </td>
        </tr>
      </table>
    </div>
    <div class="sum-container">
      <div style="display: flex; justify-content: space-between">
        <p class="total">UKUPNO</p>
        <p class="total-price">{{ getTotalPrice().toFixed(2) }} EUR</p>
      </div>
      <main-button
        v-if="showNext"
        style="border-radius: 0; margin-top: 2rem"
        color="#333"
        @click="handleNext"
      >
        Nastavi s kupnjom
      </main-button>
    </div>
  </div>
</template>

<script>
import { exchangeRate } from '@/utils'

export default {
  name: 'shopping-cart',
  components: {},
  props: {
    order: {
      type: Array,
      default: () => [],
    },
    showNext: {
      type: Boolean,
      default: true,
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({ user: null, exchangeRate }),
  methods: {
    modifyOrderData() {
      const updatedData = []
      this.order.map(item => {
        const existingItem = updatedData.find(data => data.id === item.id)
        existingItem ? (existingItem.count += 1) : updatedData.push({ ...item, count: 1 })
      })

      return updatedData
    },
    getTotalPrice() {
      return this.order.reduce((acc, curr) => (acc += Number(curr.price)), 0)
    },
    handleNext() {
      return this.$emit('next', `EUR ${this.getTotalPrice().toFixed(2)}`)
    },
  },
}
</script>

<style scoped>
.cart-container {
  gap: 16px;
  border-top: 2px solid #000;
  border-bottom: 2px solid #000;
  background: #fff;
  height: fit-content;
}
.cart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.edit-button {
  border-radius: 0;
}
.wp-table {
  width: 100%;
  margin-top: 1rem;
  border-collapse: collapse;
  table-layout: fixed;
}
.wp-table tr {
  border-bottom: 1px solid rgba(151, 151, 151, 0.5);
}
.wp-table th:first-child,
.wp-table td:first-child {
  word-break: keep-all;
}

.wp-table th:nth-child(2),
.wp-table td:nth-child(2) {
  padding-right: 2rem;
  text-align: right;
  @media screen and (max-width: 800px) {
    padding-right: 1rem;
  }
  @media screen and (max-width: 400px) {
    padding-right: 2rem;
  }
  margin: auto;
}

.wp-table tr:last-child {
  border-bottom: none;
}

.wp-table td,
.wp-table th {
  padding: 6px 6px;
  display: table-cell;
  text-align: left;
  vertical-align: top;
  color: #333333;
}
th {
  color: #333;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 550;
  line-height: 120%; /* 14.4px */
  text-transform: uppercase;
}
td {
  color: #333;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
}
.cart-title {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Rubik;
  font-size: 20px;
  font-style: normal;
  font-weight: 550;
  line-height: 120%; /* 24px */
  letter-spacing: -0.6px;
}
.sum-container {
  border-top: 2px solid #000;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
}
.total-price {
  color: #333;
  text-align: right;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Rubik;
  font-size: 20px;
  font-style: normal;
  font-weight: 550;
  line-height: 120%; /* 24px */
  letter-spacing: -0.6px;
  text-transform: uppercase;
}
.total {
  color: #333;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
}
p {
  margin: 0;
}
</style>
